import BaseListener from "./baseListener";
import { TrackEvent } from "./baseListener";
class FieldErrorListener extends BaseListener {
  private observer: any = null;

  constructor() {
    super();
    this.createObserver();
  }

  private createObserver() {
    this.observer = new MutationObserver(() => {
      (this.config.container as HTMLElement).querySelectorAll('.winitd-form-item-explain-error').forEach((el: Element) => {
        const htmlEl = el as HTMLElement;
        if (!htmlEl.dataset?.trackerBound) {
          htmlEl.dataset.trackerBound = 'true';
          const formItem = htmlEl.closest('.winitd-form-item');
          const labelElement = formItem?.querySelector<HTMLElement>('.winitd-form-item-label label');
          let fieldLabel = labelElement?.innerText?.trim() ?? '';
          if (!fieldLabel) {
            fieldLabel = formItem?.closest('.winitd-row')?.querySelector<HTMLElement>('.winitd-form-item-label label')?.innerText?.trim() ?? '';
          }
          let fieldError = htmlEl.innerText;
          const selectedVal = formItem?.querySelector<HTMLElement>('.winitd-select-selection-item')?.innerText?.trim();
          const inputEl = formItem?.querySelector<HTMLInputElement | HTMLTextAreaElement>('input,textarea');
          let fieldKey = inputEl?.getAttribute?.('id') || '';
          let fieldVal = inputEl?.value;
          let checkboxVal = '';
          if (inputEl?.closest('.winitd-checkbox')) {
            checkboxVal = inputEl.closest('.winitd-checkbox')?.classList?.contains('winitd-checkbox-checked') ? 'Y' : 'N';
            fieldKey = inputEl?.value;
          } else if (inputEl?.closest('.winitd-radio')) {
            checkboxVal = inputEl.closest('.winitd-radio')?.classList?.contains('winitd-radio-checked') ? 'Y' : 'N';
            fieldKey = inputEl?.value;
          } else {
            fieldVal = inputEl?.value ?? '';
          }
          //表格布局的控件
          let thLabel = '';
          if (!fieldLabel && htmlEl?.closest('td')) {
            let tdIndex = htmlEl?.closest('td')?.cellIndex;
            let theadTr = htmlEl?.closest('table')?.querySelector('thead tr:last-child');
            if (tdIndex !== undefined && theadTr) {
              thLabel = theadTr.querySelectorAll('th')[tdIndex]?.innerText?.trim();
            }
          }
          this.config.onEmit({
            nodeType: 'fieldError',
            nodeName: htmlEl.nodeName,
            fieldKey,
            fieldLabel: fieldLabel || thLabel || '',
            fieldVal: fieldVal || selectedVal || checkboxVal,
            fieldError,
            timestamp: Date.now(),
          },htmlEl);
        }
      });
    });
  }

  start(onEmit: (event: TrackEvent,el?:HTMLElement) => void,container: HTMLElement) {
    this.config = {
      onEmit: onEmit,
      container: container,
    };
    this.observer.observe(this.config.container, {
      childList: true,
      subtree: true
    });
  };


  stop() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

export default FieldErrorListener;
